export default {
  incentiveScreen: {
    goBack: 'Go back',
  },
  notAvailable: {
    headline: "This offer isn't available",
    body: "This promotion has ended or isn't available for your account.",
    goBack: 'Go back',
  },
  unsupportedContent: {
    headline: 'Update the app to see this offer',
    body: 'This offer needs the latest version of the Varo app.',
    updateApp: 'Update app',
    goBack: 'Go back',
  },
  sweepstakes: {
    intro: {
      eyebrow: 'Ready, set, win',
      headline: 'Your chance at {{maxPrize}}',
      body: 'From coffee runs to grocery trips, make your everyday purchases count! Spend $10 or more with your Believe secured card for a chance to win cash prizes.',
      join: 'Join the giveaway',
      howItWorks: 'How it works',
    },
    disclosure: {
      intro: {
        body: 'The Grand Giveaway runs from {{startDate}} to {{endDate}}. No purchase necessary. See',
        terms: 'terms',
        end: 'for details.',
      },
      howItWorks: {
        body: 'No purchase necessary. See',
        terms: 'Terms',
        end: 'for full details',
      },
    },
    howItWorks: {
      title: 'How it works',
      entries: {
        title: 'Get chances with every purchase',
        body: 'The amount you spend determines how many chances you get.',
        purchaseAmount: 'Purchase amount',
        chancesToWin: 'Chances to win',
      },
      prizes: {
        title: 'Your purchases have a deadline',
        body: 'The giveaway starts {{startDate}}. Each drawing has its own entry cutoff date:',
        winnerCount: '{{count}} winner',
        winnerCount_plural: '{{count}} winners',
      },
    },
    optedIn: {
      title: "You're in!",
      body: 'Start swiping to earn chances to win up to {{maxPrize}}. Every purchase of $10 or more counts.',
      bodyWithoutPrize:
        'Start swiping to earn chances to win. Every purchase of $10 or more counts.',
      continue: 'Continue',
    },
    tracker: {
      eyebrow: 'Ready, set, win',
      headline: 'Grand Giveaway',
      body: 'Spend $10 or more with your Believe secured card for a chance to win cash prizes.',
      pendingEligibility:
        'Your card opened today, so purchases start counting tomorrow.',
      chancesToWin: 'Your chances to win',
      nextGiveaway: 'Next purchase deadline',
      winnerCount: '{{count}} winner',
      winnerCount_plural: '{{count}} winners',
      updatesDaily: 'Your chances to win update daily.',
      howItWorks: 'How it works',
    },
    winner: {
      eyebrow: 'Congrats',
      headline: 'You won {{amount}}!',
      headlineWithoutAmount: 'You won!',
      body: 'You won in our {{drawingDate}} Grand Giveaway. We will deposit your {{amount}} prize into your Believe Secured Account ending in {{accountLastFour}}.',
      bodyWithoutAccount:
        'You won in our {{drawingDate}} Grand Giveaway. We will deposit your {{amount}} prize into your Believe Secured Account.',
      bodyWithoutAward:
        'You won in our Grand Giveaway. We will deposit your prize into your Believe Secured Account.',
      footnote: "Winners can't enter future drawings.",
      believeAccount: 'Believe account',
    },
    accountCard: {
      promo: {
        title: 'Win up to {{maxPrize}}',
        join: 'Join the giveaway',
      },
      progress: {
        title: 'Chances to win: {{chances}}',
        body: 'Spend $10+ to earn more chances to win cash prizes.',
        viewSweepstakes: 'Grand Giveaway',
      },
      winner: {
        title: 'You won {{amount}}!',
        titleWithoutAmount: 'You won!',
        body: 'Your prize is ready.',
        prizeDetails: 'Prize details',
      },
    },
    prerequisiteSheet: {
      title: 'Let’s get you started!',
      description:
        'Use a Believe secured card for everyday purchases of $10 or more to earn chances to win cash prizes.',
      disclaimer: 'No purchase necessary.',
      applyForBelieve: 'Apply for Believe secured card',
      skipSweepstakes: 'No, thanks',
    },
  },
};
